<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "@/components/PhotoBox.vue";
import { formatedDate } from "@/utils/proposalValidation";

export default {
  name: "FPTemp2",
  components: {
    SpellCheckedText,
    PhotoBox
  },
  props: {
	proposal:Object,
	},
  created(){ 
		console.log('In FPTemp2 created');
		console.log(this.proposal);
  },
  methods: {
    formatedDate
  }
};
</script>

<template>
  <div class="main-container" :style="{
    '--header-color': proposal.style.colorScheme && proposal.style.colorScheme.header,
    '--body-color': proposal.style.colorScheme && proposal.style.colorScheme.body,
    '--footer-color': proposal.style.colorScheme && proposal.style.colorScheme.footer,
    '--heading-color': proposal.style.heading.color,
    '--heading-size': proposal.style.heading.size + 'px',
    '--heading-font': proposal.style.heading.font,
    '--heading-bold': proposal.style.heading.bold ? 700 : 400,
    '--heading-italic': proposal.style.heading.italic ? 'italic' : 'normal',
    '--heading-underline': proposal.style.heading.underline
      ? 'underline'
      : 'none',
    '--label-color': proposal.style.label.color,
    '--label-size': proposal.style.label.size + 'px',
    '--label-font': proposal.style.label.font,
    '--label-bold': proposal.style.label.bold ? 700 : 400,
    '--label-italic': proposal.style.label.italic ? 'italic' : 'normal',
    '--label-underline': proposal.style.label.underline
      ? 'underline'
      : 'none',
    '--text-color': proposal.style.text.color,
    '--text-size': proposal.style.text.size + 'px',
    '--text-font': proposal.style.text.font,
    '--text-bold': proposal.style.text.bold ? 700 : 400,
    '--text-italic': proposal.style.text.italic ? 'italic' : 'normal',
    '--text-underline': proposal.style.text.underline ? 'underline' : 'none',
  }">
    <div class="frontPage">
      <div class="header-sec">
        <div class="logo-sec photobox">
          <PhotoBox :project="proposal" type="logo" bgColor="transparent" objectFit="contain" />
        </div>
        <div class="banner top-banner" />
      </div>

      <div class="info-sec">
        <div class="detail-sec">
          <p>
            <SpellCheckedText :value="proposal.name || ''" @input="proposal.name = $event" />
          </p>
          <p>
            <SpellCheckedText :value="proposal.address || ''" @input="proposal.address = $event" />
            <span>{{ proposal.address ? ', ' : '' }}</span>
            <SpellCheckedText :value="proposal.city || ''" @input="proposal.city = $event" />
            <span>{{ proposal.city ? ', ' : '' }}</span>
            <SpellCheckedText :value="proposal.stateProvince || ''" @input="proposal.stateProvince = $event" />
          </p>
        </div>

        <div class="submission-sec">
          <div>
            <h5>SUBMISSION DATE</h5>
            <p>
              {{ formatedDate(proposal.submissionDate, "/") }}
            </p>
          </div>

          <div>
            <h5>SUBMITTED BY</h5>
            <p>
              <SpellCheckedText :value="proposal.submittedBy || ''" @input="proposal.submittedBy = $event" />
            </p>
          </div>
        </div>
      </div>

      <div class="projects-sec">
        <div v-for="(project, index) in proposal.projects" :key="index" class="photobox">
          <PhotoBox :project="project" height="350px" :bgColor="proposal.style.colorScheme && proposal.style.colorScheme.body" />
        </div>
        <div v-if="proposal.projects.length === 1" class="imageBox" />
        <div v-if="proposal.projects.length === 0" class="imageBox" />
        <div v-if="proposal.projects.length === 0" class="imageBox" />
      </div>
      <div class="banner bottom-banner" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.main-container {
  display: block;
  width: 211mm;
  height: 296.83mm;
  min-height: 296.83mm;
  position: relative;
  box-sizing: border-box;
  background: white;

  &:hover {
    .photobox :deep(.photo-overlay) {
      opacity: 1;
    }

    .photobox :deep(img) {
      opacity: 0.9;
    }
  }

  .frontPage {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    margin: auto;

    .banner {
      min-height: 80px;

      &.top-banner {
        background: var(--header-color);
      }

      &.bottom-banner {
        background: var(--footer-color);
      }
    }

    .header-sec {
      display: grid;
      grid-template-columns: 1fr 3fr;
      gap: 20px;
      width: 100%;
      margin-bottom: 50px;

      .logo-sec {
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--header-color);
        width: 193px;
        height: 80px;
      }
    }

    .info-sec {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: var(--body-color);
      padding: 50px 80px;
      min-height: 460px;
      margin-bottom: 50px;

      .detail-sec {
        display: flex;
        flex-direction: column;
        gap: 10px;
        text-align: center;
        border-bottom: 3px solid white;

        p {
          margin: 0px;
          color: var(--heading-color);
          font-size: var(--heading-size);
          font-family: var(--heading-font);
          font-weight: var(--heading-bold);
          font-style: var(--heading-italic);
          text-decoration: var(--heading-underline);
        }
      }

      .submission-sec {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 100px 0px 0px 0px;
        font-size: 20px;
        text-align: center;

        h5 {
          color: var(--label-color);
          font-size: var(--label-size);
          font-family: var(--label-font);
          font-weight: var(--label-bold);
          font-style: var(--label-italic);
          text-decoration: var(--label-underline);
        }

        p {
          color: var(--text-color);
          font-size: var(--text-size);
          font-family: var(--text-font);
          font-weight: var(--text-bold);
          font-style: var(--text-italic);
          text-decoration: var(--text-underline);
        }
      }
    }

    .projects-sec {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 30px;
      height: 350px;
      margin-bottom: 50px;

      .img-sec {
        width: 100%;
        height: 350px;
      }

      .imageBox {
        background: var(--body-color);
        width: 100%;
        height: 350px;
      }
    }
  }
}
</style>